// extracted by mini-css-extract-plugin
export default {"aboutMe":"home_aboutMe__Z6gRF","active":"home_active__KjOue"};